module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    attrs: {
      "close-on-content-click": false,
      "nudge-bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-chip', _vm._g({
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, on), [_c('v-avatar', {
          attrs: {
            "left": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("expand_more")])], 1), _vm._v("\n      Mailchimp\n    ")], 1)]
      }
    }]),
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, 'v-menu', _vm.menuAttrs, false), [_vm._v(" "), _c('span', [(_vm.requests.get.loading) ? _c('v-card', {
    staticClass: "text-center",
    attrs: {
      "width": "360px"
    }
  }, [_c('center', [_c('v-progress-circular', {
    staticClass: "ma-5",
    attrs: {
      "size": "64",
      "color": "amber",
      "indeterminate": ""
    }
  })], 1)], 1) : _c('v-card', {
    attrs: {
      "width": "400px"
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.save
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        " + _vm._s(_vm.email) + "\n        "), _c('v-spacer'), _vm._v(" "), (_vm.member && _vm.member.status) ? _c('v-chip', {
    staticClass: "v-chip--x-small"
  }, [_vm._v(_vm._s(_vm.member.status))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.requests.get.status === 404) ? [_c('v-card-text', [_vm._v("\n          This email is not in your Mailchimp mailing list.\n          Would you like to add them?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Add to Mailchimp")])], 1)] : _vm._e(), _vm._v(" "), (_vm.member && _vm.requests.get.status === 200) ? [_c('v-card-text', [_c('strong', [_vm._v("Email client:")]), _vm._v(" " + _vm._s(_vm.member.email_client || "Unknown")), _c('br'), _vm._v(" "), (_vm.member.stats) ? _c('v-layout', {
    staticClass: "my-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('strong', [_vm._v("Open rate")]), _vm._v(" "), _c('v-progress-circular', {
    staticClass: "ml-2",
    attrs: {
      "rotate": 270,
      "size": 36,
      "width": "3",
      "color": "success",
      "value": _vm.asPercent(_vm.member.stats.avg_open_rate)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.asPercent(_vm.member.stats.avg_open_rate)) + "%\n              ")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Click rate:")]), _vm._v(" "), _c('v-progress-circular', {
    staticClass: "ml-2",
    attrs: {
      "rotate": 270,
      "size": 36,
      "width": "3",
      "color": "info",
      "value": _vm.asPercent(_vm.member.stats.avg_click_rate)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.asPercent(_vm.member.stats.avg_click_rate)) + "%\n              ")])], 1), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "overline"
  }, [_vm._v("Mailchimp rating")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "half-increments": "",
      "small": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: (_vm.member.member_rating),
      callback: function($$v) {
        _vm.$set(_vm.member, "member_rating", $$v)
      },
      expression: "member.member_rating"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Last changed")]), _vm._v(" " + _vm._s(_vm.dateformat(_vm.member.last_changed)) + "\n          "), _vm._v(" "), (_vm.member.tags && _vm.member.tags.length > 0) ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l((_vm.member.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": "",
        "outlined": ""
      }
    }, [_vm._v("\n              " + _vm._s(tag.name) + "\n            ")])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.relationshipId && this.member && this.member.id) ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "loading": _vm.requests.save.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.mailchimpURL) ? _c('v-btn', {
    attrs: {
      "href": _vm.mailchimpURL,
      "target": "_blank",
      "small": "",
      "color": "success"
    }
  }, [_vm._v("Open in Mailchimp "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e()], 1)] : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2193bc92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Mailchimp/MailchimpChip.vue
// module id = 1352
// module chunks = 9